// src/lib/utils.ts
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatNumber(num: number): string {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K';
  }
  return num.toString();
}

export function getStreakEmoji(streak: number): string {
  if (streak >= 365) return '👑';
  if (streak >= 180) return '💎';
  if (streak >= 90) return '🔥';
  if (streak >= 30) return '⚡';
  if (streak >= 7) return '🌟';
  return '✨';
}

export function getAchievements(stats: { totalDays: number; currentStreak: number; longestStreak: number }) {
  const achievements = [];

  // Streak achievements
  if (stats.currentStreak >= 7) achievements.push({ id: 'week-warrior', title: 'Week Warrior', icon: '🌟' });
  if (stats.currentStreak >= 30) achievements.push({ id: 'month-master', title: 'Month Master', icon: '⚡' });
  if (stats.currentStreak >= 90) achievements.push({ id: 'quarter-champion', title: 'Quarter Champion', icon: '🔥' });
  if (stats.currentStreak >= 180) achievements.push({ id: 'half-year-hero', title: 'Half Year Hero', icon: '💎' });
  if (stats.currentStreak >= 365) achievements.push({ id: 'year-legend', title: 'Year Legend', icon: '👑' });

  // Total days achievements
  if (stats.totalDays >= 10) achievements.push({ id: 'dedicated-10', title: 'First 10!', icon: '🎯' });
  if (stats.totalDays >= 50) achievements.push({ id: 'dedicated-50', title: 'Half Century', icon: '🏆' });
  if (stats.totalDays >= 100) achievements.push({ id: 'dedicated-100', title: 'Centurion', icon: '🎖️' });
  if (stats.totalDays >= 250) achievements.push({ id: 'dedicated-250', title: 'Elite Tester', icon: '🌠' });
  if (stats.totalDays >= 500) achievements.push({ id: 'dedicated-500', title: 'Testing Legend', icon: '🔱' });

  return achievements;
}

